import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HeroCarousel from '../Common/HeroCarousel';
import { FaHandsHelping, FaGlobeAmericas, FaArrowLeft } from 'react-icons/fa';
import image7 from '../../Assets/image 7.png';
import image8 from '../../Assets/image 8.png';

const OutreachService = () => {
  const navigate = useNavigate();

  const ministryAreas = [
    {
      id: 1,
      icon: <FaHandsHelping className="text-3xl text-red-500" />,
      title: 'Community Outreach',
      description: 'Serving our local community through homeless shelters, foodstuffs, and neighbourhood evangelism to demonstrate God\'s love in practical ways.',
      image: image7,
      monthlyPrograms: [
        'Street evangelism outreaches',
        'Homeless shelter meals'
      ],
      specialEvents: [
        'Community health fairs',
        'Back-to-school supplies'
      ]
    },
    {
      id: 2,
      icon: <FaGlobeAmericas className="text-3xl text-teal-500" />,
      title: 'Missions Ministry',
      description: 'Reaching the nations with Gospel through short term mission trips, missionary support, and international church partnerships to plant churches and train leaders.',
      image: image8,
      annualTrips: [
        'Medical mission trips',
        'Construction projects'
      ],
      support: [
        'Leadership conferences',
        'Vacation Bible School'
      ]
    }
  ];

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <HeroCarousel 
        title="Ministries"
        subtitle="Discover how you can grow, serve, and connect through our specialized ministries"
        height="h-[500px]"
        contentPosition="bottom"
      />

      {/* Back Button and Content Section */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          {/* Back Button */}
          <button 
            onClick={() => navigate('/ministries')}
            className="flex items-center gap-2 text-primary hover:text-blue-700 mb-8 font-sf-pro font-medium"
          >
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <FaArrowLeft className="text-white text-sm" />
            </div>
            Back
          </button>

          {/* Title and Description */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Outreach & Service Ministries</h2>
            <p className="text-gray-700 text-lg max-w-3xl mx-auto font-sf-pro">
              Taking God's love beyond our walls to serve our community and share the Gospel with those in need.
            </p>
          </div>

          {/* Ministry Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
            {ministryAreas.map((area) => (
              <div key={area.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="relative h-56">
                  <img 
                    src={area.image} 
                    alt={area.title} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    {area.icon}
                    <h3 className="text-xl font-bold">{area.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm font-sf-pro leading-relaxed mb-4">
                    {area.description}
                  </p>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <h4 className="font-bold text-sm mb-2">
                        {area.id === 1 ? 'Monthly Programs' : 'Annual Trips'}
                      </h4>
                      <ul className="space-y-2">
                        {(area.id === 1 ? area.monthlyPrograms : area.annualTrips).map((item, index) => (
                          <li key={index} className="flex items-start gap-2 text-sm text-gray-700 font-sf-pro">
                            <span className="text-orange-500 mt-1">●</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div>
                      <h4 className="font-bold text-sm mb-2">
                        {area.id === 1 ? 'Special Events' : 'Support'}
                      </h4>
                      <ul className="space-y-2">
                        {(area.id === 1 ? area.specialEvents : area.support).map((item, index) => (
                          <li key={index} className="flex items-start gap-2 text-sm text-gray-700 font-sf-pro">
                            <span className="text-orange-500 mt-1">●</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Button */}
          <div className="flex justify-center">
            <button 
              onClick={() => navigate('/ministries/join')}
              className="bg-black text-white px-8 py-3 rounded-lg font-medium hover:bg-gray-900 transition font-sf-pro"
            >
              Join us
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OutreachService;
